export const BRIDGE_KEY = '__LIVECHAT_SDK_CONTEXT__'
export const BRIDGE_EVENT = 'livechat-sdk-ready'
export const FALLBACK_DELAY_MS = 500
